import { Alert, Box } from '@pinchenterprisesnpm/friday-ui'
import { connect, FormikProps } from 'formik'
import { DaysListItem } from 'features/shift-post-v2/steps/shift-details-step/components/schedule-section/components/days-list-item/days-list-item'
import { SHIFT_TYPE } from 'models/Shift'
import { useSelector } from 'react-redux'
import { selectBusinessEntity } from '@src/data/BusinessEntity/selectors'
import { STARTING_DAY_ALERT_MESSAGE } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/constants'
import { checkIfBusinessRequiresNextWorkingDaySelection } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { INewEditModalFormValues } from '../new-edit-modal.form'

interface IIndividualDaysListProps {
  formik: FormikProps<INewEditModalFormValues>
}

export const IndividualDaysList = connect<IIndividualDaysListProps>(({ formik }) => {
  const { errors, values } = formik
  const businessEntity = useSelector(selectBusinessEntity)

  const hasNextWorkingDaySelected = values.days.some((day) => day.starting_day && day.working)

  return (
    <Box mt='md'>
      {/* Single day shifts */}
      {values.type === SHIFT_TYPE.SINGLEDAY && values.single_day_date && (
        <>
          {errors.single_day_date && Array.isArray(errors.single_day_date) && (
            <Alert
              message='One or more selected single day shifts have an invalid Hourly Pay Rate.'
              type='danger'
            />
          )}

          <DaysListItem
            key={values.single_day_date.toISOString()}
            singleDayDate={values.single_day_date}
            businessEntity={businessEntity}
          />
        </>
      )}

      {/* Multiday shift or Recurring shift */}
      {(values.type === SHIFT_TYPE.MULTIDAY || values.is_recurring_shift) && (
        <>
          {errors.days && Array.isArray(errors.days) && (
            <Alert
              message='One or more selected days have an invalid Hourly Pay Rate.'
              type='danger'
            />
          )}
          {checkIfBusinessRequiresNextWorkingDaySelection(businessEntity!) &&
            !hasNextWorkingDaySelected && (
              <Alert message={STARTING_DAY_ALERT_MESSAGE} type='primary' />
            )}
          {values.days.length > 0 &&
            values.days.map((day) => (
              <DaysListItem key={day.id} day={day} businessEntity={businessEntity} />
            ))}
        </>
      )}
    </Box>
  )
})
